import { makeStyles, Theme, createStyles, lighten } from "@material-ui/core";

export const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      overflow: "scroll",
      display: "flex",
      justifyContent: "space-between",
    },

    toolbarActionsWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },

    highlight:
      theme.palette.type === "light"
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {},
  })
);

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    button: {
      margin: theme.spacing(1),
      padding: "auto 200px",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    mainSearchWrapper: {
      marginRight: theme.spacing(1),
      minWidth: 150,
    },
    profilePic: {
      height: "40px",
      width: "40px",
      borderRadius: "50%",
    },
  })
);
